import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, MessageProps, Transition } from 'semantic-ui-react';
import styled from 'styled-components';
import LoaderComponent from 'components/LoaderComponent';

const TransparentLoaderComponent = styled(LoaderComponent)`
  background-color: transparent !important;
`;

interface Props extends MessageSourceProps {
  error: boolean,
  visible: boolean,
  errorMessage: string,
  goToLogin: () => void,
  renderMessage: (header: string, text: string, messageProps: MessageProps) => React.ReactNode
}

class ValidatingTokenSegment extends Component<Props> {

  render(): React.ReactNode {

    const {error, visible, getMessage} = this.props;

    return (
        <Transition animation={"scale"} duration={400} visible={visible}>
          <div>
            {error
                ? this.renderTokenNotValid()
                : <TransparentLoaderComponent message={getMessage("resetPassword.validatingToken")} inverted/>}
          </div>
        </Transition>
    );
  }

  renderTokenNotValid = (): React.ReactNode => {

    const {getMessage, errorMessage, renderMessage, goToLogin} = this.props;

    const errorHeader = getMessage('resetPassword.token');

    return (
        <React.Fragment>
          <Button type='button' basic fluid onClick={goToLogin}>{getMessage('resetPassword.goToLogin')}</Button>
          {renderMessage(errorHeader, errorMessage, {negative: true})}
        </React.Fragment>
    )
  };
}

export default withMessages(ValidatingTokenSegment);
